import React from 'react';
import {StyleSheet, View} from 'react-native';

import Text from '../../../components/ui-controls/Text';
import Checkbox from '../../../components/ui-controls/web/CheckBox';

interface WeakPasswordBypassProps {
  visible: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const BYPASS_MESSAGE =
  "This password doesn't meet minimum strength requirements and/or has been found " +
  'in a list of leaked passwords. By ticking this box you acknowledge that you ' +
  'wish to continue with this password.';

export function WeakPasswordBypass({visible, checked, onChange}: WeakPasswordBypassProps) {
  if (!visible) return null;

  return (
    <View style={styles.container}>
      <Checkbox checked={checked} onChange={() => onChange(!checked)} style={styles.checkbox} />
      <Text style={styles.text}>{BYPASS_MESSAGE}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginVertical: 8,
    paddingHorizontal: 4,
  },
  checkbox: {
    alignSelf: 'center',
  },
  text: {
    alignSelf: 'center',
    color: '#C81E1E',
    flex: 1,
    fontSize: 12,
    justifyContent: 'center',
    marginBottom: 4,
    marginLeft: 8,
  },
});
